module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"This contest is over!","winners":"Contest winners","discover_tuango":"Discover Tuango","follow_us":"Follow us on your favourite social media"},"fr":{"title":"Ce concours est terminé!","winners":"Gagnants du concours","discover_tuango":"Découvrez Tuango","follow_us":"Suivez-nous sur vos réseaux sociaux préférés"}}')
  delete Component.options._Ctor
}
